import React, { memo, useMemo } from 'react';
import { RadioButtonType } from '../../libraries/RadioButtonTheme';
import { TooltipPosition } from '../../libraries/Tooltips';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './RadioButton.scss';
const rootClassName = 'component-radio-button';

interface RadioButtonProps
  extends Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    'value' | 'onChange'
  > {
  id?: string;
  'tooltip-position'?: TooltipPosition;
  'tooltip-text'?: string;
  value: boolean;
  theme?: RadioButtonType;
  onChange?: (value: boolean) => void;
}

function RadioButton(props: RadioButtonProps) {
  const buttonProps = useMemo(() => {
    const p: any = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.theme,
        props.className,
        `${rootClassName}-${props.value ? 'checked' : 'not'}`,
      ]),
      onClick: () => {
        if (!props.disabled) {
          props.onChange?.(!props.value);
        }
      },
    };
    delete p.value;
    delete p.onChange;
    return p as React.ButtonHTMLAttributes<HTMLButtonElement>;
  }, [props]);

  return <button {...buttonProps} />;
}

RadioButton.defaultProps = {
  disabled: false,
  value: false,
  theme: RadioButtonType.New,
};

export default memo(RadioButton);
